import { Injectable } from '@angular/core';
import {
    HttpEvent,
    HttpInterceptor,
    HttpHandler,
    HttpRequest,
    HttpResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { UIService } from 'services';

export type LoaderInterceptorHeaderKeys = 'x-loader-interceptor';

/**
 * Displays loader during server requests
 *
 * To Disable Loader set HttpHeader 'x-loader-interceptor': 'false'
 */
@Injectable({
    providedIn: 'root'
})
export class LoaderInterceptor implements HttpInterceptor {
    // Storing request into array to identify when all of them finished
    private requests: HttpRequest<any>[] = [];

    constructor(private uiService: UIService) {}

    public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const config = {
            showLoader: true,
            loaderHeader: 'x-loader-interceptor'
        };

        // Setting config via HttpHeader and removing custom headers
        if (req.headers.get(config.loaderHeader)) {
            config.showLoader = req.headers.get(config.loaderHeader) !== 'false';
            req = req.clone({
                headers: req.headers.delete(config.loaderHeader)
            });
        }

        if (config.showLoader) {
            this.requests.push(req);
            this.uiService.setLoadingState(true);

            // We create a new observable which we return instead of the original
            return Observable.create(observer => {
                // And subscribe to the original observable to ensure the HttpRequest is made
                const subscription = next.handle(req).subscribe(
                    event => {
                        if (event instanceof HttpResponse) {
                            this.removeRequest(req);
                            observer.next(event);
                        }
                    },
                    err => {
                        this.removeRequest(req);
                        observer.error(err);
                    },
                    () => {
                        this.removeRequest(req);
                        observer.complete();
                    }
                );
                // return teardown logic in case of cancelled requests
                return () => {
                    this.removeRequest(req);
                    subscription.unsubscribe();
                };
            });
        } else {
            return next.handle(req);
        }
    }

    removeRequest(req: HttpRequest<any>) {
        const index = this.requests.indexOf(req);
        if (index >= 0) this.requests.splice(index, 1);
        this.uiService.setLoadingState(this.requests.length > 0);
    }
}
